import React from 'react';
import {
    DialogContainer,
    Text,
    FuelerIcon,
    Button,
    Flex
} from '../components';

const DoneButton = Button.extend`
    height: 55px;
    width: 150px;
`;

const FuelUploadSuccess = ({online, history}) => {
    const offlineIcon = <FuelerIcon icon='upload' size='40px'/>;
    const onlineIcon = <FuelerIcon icon='check' size='40px' fill='#42B72A'/>;
    const onlineMessage = `Upload Successful`;
    const offlineMessage = `Your data will be uploaded when you gain network connectivity.`;

    return (
        <DialogContainer justifyContent='space-around'>
            <Flex style={{alignItems: 'center'}} column>
                {online ? onlineIcon : offlineIcon}
                <Text textAlign='center'>
                    {online ? onlineMessage : offlineMessage}
                </Text>
            </Flex>
            <DoneButton primary onClick={() => history.push('/')}>
                Done
            </DoneButton>
        </DialogContainer>
    );
}

export default FuelUploadSuccess;


// WEBPACK FOOTER //
// ./src/ApparatusFuel/FuelUploadSuccess.js